import React from 'react';
import { FaInstagram, FaFacebookF, FaTwitter, FaTshirt } from 'react-icons/fa';
import { GiShoppingBag } from 'react-icons/gi';
import { MdDesignServices } from 'react-icons/md';

const About = () => {
  return (
    <div className="bg-white min-h-screen px-6 py-12 md:px-16 lg:px-32 font-['Roboto']">
      <div className="flex flex-col md:flex-row items-center gap-12">

        {/* Left Content */}
        <div className="w-full md:w-1/2 space-y-6">
          <h1 className="text-5xl font-bold font-['Poppins'] text-[#854d0e]">ABOUT US</h1>
          <p className="text-lg leading-7 text-gray-600">
            <strong className='text-[#854d0e]'>FashionHub</strong> is a trailblazing fashion brand committed to providing the trendiest clothes and accessories that empower people from all walks of life. Whether you’re bold and daring or subtle and chic — we’ve got you covered.
          </p>
          <p className="text-lg leading-7 text-gray-600">
            Our journey started with a simple vision — to make top-notch fashion accessible to everyone. Today, we’re proud to be the go-to destination for everyday glam and edgy style.
          </p>
          <p className="text-lg leading-7 text-gray-600">
            At FashionHub, we believe in celebrating diversity through fashion, offering pieces that blend comfort, confidence, and creativity. Exceptional customer service and quality are stitched into everything we create.
          </p>

          {/* Highlights */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6 text-[#854d0e]">
            <div className="flex flex-col items-center">
              <FaTshirt size={30} />
              <p className="mt-2 text-sm">Trendy Apparel</p>
            </div>
            <div className="flex flex-col items-center">
              <GiShoppingBag size={30} />
              <p className="mt-2 text-sm">Affordable Fashion</p>
            </div>
            <div className="flex flex-col items-center">
              <MdDesignServices size={30} />
              <p className="mt-2 text-sm">Top-notch Design</p>
            </div>
          </div>

          {/* Social Icons */}
          <div className="flex space-x-6 mt-8 text-[#854d0e] text-2xl">
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2">
          <img
            src="https://as1.ftcdn.net/v2/jpg/03/33/81/02/1000_F_333810258_5gP2SBYroH0jtgAtI2ANibRRDe2YY7dU.jpg"
            alt="FashionHub"
            className="rounded-xl shadow-xl w-full max-h-[550px] object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
